import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { AxiosRequestConfig } from 'axios';

export type TAxiosInterceptorResponseError = {
  status: number;
  statusText: string;
  data: any;
  message: string;
};

export function isTAxiosInterceptorResponseError(obj: unknown): obj is TAxiosInterceptorResponseError {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    typeof (obj as TAxiosInterceptorResponseError).status === 'number' &&
    typeof (obj as TAxiosInterceptorResponseError).statusText === 'string' &&
    'data' in obj && // We check only for existence since 'data' can be any type
    typeof (obj as TAxiosInterceptorResponseError).message === 'string'
  );
}

type TAxiosResponseError = {
  response: {
    status: number;
    statusText: string;
    data?: any;
  };
};

export function isTAxiosResponseError(obj: unknown): obj is TAxiosResponseError {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    typeof (obj as TAxiosResponseError).response === 'object' &&
    (obj as TAxiosResponseError).response !== null &&
    typeof (obj as TAxiosResponseError).response.status === 'number' &&
    typeof (obj as TAxiosResponseError).response.statusText === 'string' &&
    ('data' in (obj as TAxiosResponseError).response || (obj as TAxiosResponseError).response.data === undefined)
  );
}

export type TAxiosBaseRequestParams = {
  url: string;
  method: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  headers?: AxiosRequestConfig['headers'];
  responseType?: AxiosRequestConfig['responseType'];
};

export type AxiosBaseQueryFn = BaseQueryFn<
  TAxiosBaseRequestParams,
  // AxiosResponse,
  TAxiosBaseResponseSuccess,
  TAxiosBaseResponseError
>;

export type TAxiosBaseQueryInput = { baseUrl: string };
export type TAxiosBaseResponseSuccess = { data: any };
export type TAxiosBaseResponseError = {
  error: {
    status: number;
    statusText: string;
    data: any;
    message: string;
  };
};
